import "./MFACodeInput.css";

import { MFACodeInputProps, useMFACodeInput } from "shared/hooks/mfaHooks";

const MFACodeInput = ({ onChange, value, disabled }: MFACodeInputProps) => {
  const { inputRefs, onKeyDown, onFocus, onInputChange } = useMFACodeInput({
    onChange,
    value,
  });

  return (
    <div className="MFACodeInput">
      {inputRefs.map((ref, i) => (
        <input
          key={i}
          name={`mfa_code_${i}`}
          className="MFACodeInput_input"
          size={1}
          onChange={(ev) => onInputChange(ev, i)}
          onKeyDown={onKeyDown}
          value={value && value.length >= i + 1 ? value[i] : ""}
          onFocus={(ev) => onFocus(ev, i)}
          ref={ref}
          autoComplete="off"
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default MFACodeInput;
